import React from 'react';
import type { CSSObject } from 'styled-components';
import { TextStyled } from './text.styled';
import { Size, Color } from './types';

interface TextProps {
  size?: keyof typeof Size;
  color?: keyof typeof Color;
  crossed?: boolean;
  error?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  children?: React.ReactNode | React.ReactNode[];
  mr?: number;
  ml?: number;
  sx?: CSSObject;
}
// TODO: alex requires work
export const Text = ({
  children,
  onClick,
  size = 'small',
  ...rest
}: TextProps) => {
  return (
    <TextStyled onClick={onClick} size={size} {...rest}>
      {children}
    </TextStyled>
  );
};
